import { CreateTeamRequest, DeleteTeamRequest, UpdateTeamRequest, ViewTeamRequest } from './team.types';

import {
  API_HOST,
  HttpDeleteOptions,
  HttpGetOptions,
  HttpPostOptions,
  HttpPutOptions,
  getHttpDeleteOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/teams`;
const getSpecificEndpoint = (externalReference: string) => `${getEndpoint()}/${externalReference}`;

export const getCreateTeamRequest = (data: CreateTeamRequest): [string, HttpPostOptions<CreateTeamRequest>] => [
  getEndpoint(),
  getHttpPostOptions(data)
];

export const getViewTeamRequest = (data: ViewTeamRequest): [string, HttpGetOptions] => [
  getSpecificEndpoint(data.teamExternalReference),
  getHttpGetOptions()
];

export const getUpdateTeamRequest = (data: UpdateTeamRequest): [string, HttpPutOptions<UpdateTeamRequest>] => [
  getEndpoint(),
  getHttpPutOptions(data)
];

export const getDeleteTeamRequest = (data: DeleteTeamRequest): [string, HttpDeleteOptions] => [
  getSpecificEndpoint(data.teamExternalReference),
  getHttpDeleteOptions()
];
